// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/posFnb.css
// module id = 1333
// module chunks = 37